import React, { useEffect } from 'react';

import Loading from '@ifit/mp-loading';

import GridSection from '../../../components/grid-section';
import InfiniteScrollRQ from '../../../components/infinite-scroll-rq';
import { getSearchState } from '../../search/state/search-state';
import { useTrainersInfiniteQuery } from '../../../client/query/trainers';
import flatten from 'lodash.flatten';
import useToolbarTitle from '@ifit/hooks/useToolbarTitle';
import { setLastTitle } from '../../../store/to-native';
import { trainersTitle } from '../../../i18n/translations';

const Trainers = () => {
  useEffect(() => {
    getSearchState().setViewContext({});
  }, []);

  const {
    data,
    fetchNextPage,
    isFetching,
    isLoading,
    isError,
  } = useTrainersInfiniteQuery();

  function fetch() {
    return fetchNextPage();
  }

  useToolbarTitle(trainersTitle(), { buttonStyle: 'back' }, () =>
    setLastTitle(trainersTitle()),
  );

  if (!data && isLoading) {
    return <Loading absolute />;
  }
  const { pages } = data;
  const hasMoreItems = pages.length && pages[pages.length - 1].hasMoreItems;
  const trainers = flatten(pages.map(p => p.data));
  return (
    <div className="trainers-view">
      <InfiniteScrollRQ
        loadMore={fetch}
        hasMoreItems={hasMoreItems}
        libraryCards={trainers}
        isFetching={isFetching}
        isError={isError}
      >
        <GridSection />
      </InfiniteScrollRQ>
    </div>
  );
};

export default Trainers;
